import {request} from '@/shared/api/apiClient'
import {GROWTHBOOK_CONFIG} from '@/shared/config/apiConfig/global/growthBook/growthBookConfig'

export const getGrowthBookData = () => request(GROWTHBOOK_CONFIG.GROWTHBOOK_CONFIG, '')
